import React from 'react';
import { Modal, Row, Col, Table, Badge, Button } from 'react-bootstrap';
import { BarChart3 } from 'lucide-react';
import { strategies } from './BacktestingConfig'; // Import our config

const StrategyDocumentationModal = ({ strategyId, showDocumentation, setShowDocumentation }) => {
  const strategy = strategies.find((s) => s.id === strategyId);
  if (!strategy || !strategy.documentation) return null;

  const doc = strategy.documentation;
  const riskColor = {
    Low: "success",
    Medium: "warning",
    High: "danger",
    "Very High": "danger",
  };

  return (
    <Modal
      show={showDocumentation}
      onHide={() => setShowDocumentation(false)}
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <BarChart3 size={20} className="me-2" />
          {strategy.name} Documentation
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="strategy-docs">
          <div className="mb-4">
            <h5>Overview</h5>
            <p className="text-muted">{doc.overview}</p>
          </div>

          <div className="mb-4">
            <h5>Parameters</h5>
            <div className="table-responsive">
              <Table striped bordered size="sm">
                <thead>
                  <tr>
                    <th>Parameter</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(doc.parameters).map(([key, value]) => (
                    <tr key={key}>
                      <td className="fw-semibold">{key}</td>
                      <td>{value}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>

          <div className="mb-4">
            <h5>Trading Signals</h5>
            <Row>
              <Col md={6}>
                <div className="p-3 border rounded bg-success bg-opacity-10">
                  <h6 className="text-success">BUY Signal</h6>
                  <p className="mb-0 small">{doc.signals.buy}</p>
                </div>
              </Col>
              <Col md={6}>
                <div className="p-3 border rounded bg-danger bg-opacity-10">
                  <h6 className="text-danger">SELL Signal</h6>
                  <p className="mb-0 small">{doc.signals.sell}</p>
                </div>
              </Col>
            </Row>
          </div>

          <div className="mb-4">
            <h5>Strategy Information</h5>
            <Row>
              <Col md={6}>
                <div className="p-3 border rounded">
                  <h6 className="text-info">Best For</h6>
                  <p className="mb-0 small">{doc.bestFor}</p>
                </div>
              </Col>
              <Col md={6}>
                <div className="p-3 border rounded">
                  <h6 className="">Risk Level</h6>
                  <Badge bg={riskColor[doc.riskLevel]} className="fs-6">
                    {doc.riskLevel}
                  </Badge>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          size="sm"
          onClick={() => setShowDocumentation(false)}
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default StrategyDocumentationModal;
